module.exports = __webpack_public_path__ + "media/mypage/images/sample_20200210-e9d5ae1e875eee1e028e52d8769b60fa.jpg";